module.exports = __webpack_public_path__ + "static/gold-b9aecb230d7b8463ba5365d5bbacb2a3.svg";